import React, { useEffect, useRef, useState } from 'react';
import { Button, Col, DatePicker, Form, Input, Radio, Row, Select } from 'antd';
import Customer from '../../classes/customer';
import { Utils } from '../../tools/utils';
import { FormInstance } from 'antd/lib/form';
import { StringFormats, ValidationPatterns } from '../../config/config';
import { useTranslation } from 'react-i18next';
import { useStore } from 'store';
import SicuriProtettiServices from 'js/data/sicuri-protetti-services';

const { emailPattern, postalCodePattern, telefonNumberPattern } = ValidationPatterns;
const { shortDateFormat } = StringFormats;
const utils = new Utils();
const { Option } = Select;
const twoColFormItemLayout = {
    wrapperCol: { span: 14 },
    labelCol: { span: 6 },
};

interface IProps {
    data: Customer;
    formIsValid: (isValid: boolean, values?: any) => void;
    nextStep: () => void;
}

const CustomerForm = (props: IProps) => {
    const { t } = useTranslation();
    const formRef = useRef<FormInstance>(null);
    const setLoading = useStore((state) => state.setLoading);

    const [citiesOfBirth, setCitiesOfBirth] = useState<simpleStruct[]>([]);
    const [citiesOfResidence, setCitiesOfResidence] = useState<simpleStruct[]>([]);
    const [, /* citiesSociety */ setCitiesSociety] = useState<simpleStruct[]>([]);
    const [states, setStates] = useState<simpleStruct[]>([]);
    const [docTypes, setDocTypes] = useState<simpleStruct[]>([]);
    const [isBusiness, setIsBusiness] = useState<number>(props.data.isBusiness);

    const onFinish = (values: any) => {
        if (values.isBusiness === undefined) values.isBusiness = false;
        if (document.getElementById('state-' + values.stateOfBirthId) != null)
            values.stateOfBirth = document.getElementById('state-' + values.stateOfBirthId)!.getAttribute('data-state');
        if (document.getElementById('cityB-' + values.cityOfBirthId) != null)
            values.cityOfBirth = document.getElementById('cityB-' + values.cityOfBirthId)!.getAttribute('data-city');
        if (document.getElementById('cityR-' + values.cityResidenceId) != null)
            values.cityResidence = document.getElementById('cityR-' + values.cityResidenceId)!.getAttribute('data-city');
        if (document.getElementById('cityR-' + values.cityResidenceId) != null)
            values.provinceResidenceId = document.getElementById('cityR-' + values.cityResidenceId)!.getAttribute('data-province');
        if (document.getElementById('cityS-' + values.citySocietyId) != null)
            values.citySociety = document.getElementById('cityS-' + values.citySocietyId)!.getAttribute('data-city');
        if (document.getElementById('cityS-' + values.citySocietyId) != null)
            values.provinceSocietyId = document.getElementById('cityS-' + values.citySocietyId)!.getAttribute('data-province');
        if (document.getElementById('doctype-' + values.docTypeId) != null)
            values.docType = document.getElementById('doctype-' + values.docTypeId)!.getAttribute('data-doctype');

        if (isBusiness === 1 && (values.sdi === undefined || values.sdi === '') && (values.pec === undefined || values.pec === '')) {
            props.formIsValid(false, t('errorMessages.insertSdiOrPec'));
        } else {
            props.formIsValid(true, values);
            props.nextStep();
        }
    };

    const onFinishFailed = () => {
        props.formIsValid(false);
    };

    const onStateChange = async (values: any) => {
        formRef.current!.setFieldsValue({ cityOfBirthId: undefined });
        const cities = await SicuriProtettiServices.getCities(values);
        setCitiesOfBirth(cities);
    };

    const onCitySelectedR = async (value: any) => {
        formRef.current!.setFieldsValue({
            postalCodeResidence: document.getElementById('cityR-' + value)!.getAttribute('data-postalcode'),
        });
    };

    const onCitySelectedS = async (value: any) => {
        formRef.current!.setFieldsValue({ postalCodeSociety: document.getElementById('cityS-' + value)!.getAttribute('data-postalcode') });
    };

    useEffect(() => {
        const getData = async () => {
            setLoading(true);
            const states = await SicuriProtettiServices.getStates();
            const citiesOfBirth = await SicuriProtettiServices.getCities(props.data.stateOfBirthId);
            const citiesOfResidence = await SicuriProtettiServices.getCities('IT');
            const citiesSociety = await SicuriProtettiServices.getCities('IT');
            const docTypes = await SicuriProtettiServices.getCustomerDocTypes();
            setStates(states);
            setCitiesOfBirth(citiesOfBirth);
            setCitiesOfResidence(citiesOfResidence);
            setCitiesSociety(citiesSociety);
            setDocTypes(docTypes);
            setIsBusiness(props.data.isBusiness);
            setLoading(false);
        };

        getData();
        // eslint-disable-next-line
    }, []);

    const onChangeCusType = (e: any) => {
        setIsBusiness(e.target.value);
    };

    const customerTypes = [
        { label: t('customerClass.customerTypes.type0'), value: 0 },
        { label: t('customerClass.customerTypes.type1'), value: 1 },
    ];

    return (
        <Form id="customer-form" className="center" ref={formRef} onFinish={onFinish} onFinishFailed={onFinishFailed}>
            <h2 className="font-weight-600 title-content">{t('sicuri&protetti.titles.title2')}</h2>
            <br />
            <Row>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                    <Form.Item name="isBusiness" initialValue={props.data.isBusiness}>
                        <Radio.Group
                            onChange={(e) => onChangeCusType(e)}
                            options={customerTypes.map((cusType) => ({
                                label: t(cusType.label),
                                value: cusType.value,
                            }))}
                            optionType="button"
                            buttonStyle="solid"
                        />
                    </Form.Item>
                    {/*
                    <Form.Item
                        {...oneColFormItemLayout}
                        name="isBusiness"
                        label={t("customerClass.society")}
                        valuePropName="checked"
                        initialValue={isBusiness}>
                        <Switch defaultChecked={isBusiness} checkedChildren={"Società"} unCheckedChildren={"Persona fisica"}/>
                    </Form.Item>
                    */}
                </Col>
            </Row>
            {isBusiness === 0 ? (
                <>
                    <Row>
                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                            <Form.Item
                                {...twoColFormItemLayout}
                                name="surname"
                                label={t('customerClass.surname')}
                                initialValue={props.data.surname}
                                rules={[
                                    {
                                        required: true,
                                        message: t('errorMessages.surnameReq'),
                                    },
                                ]}
                            >
                                <Input placeholder={t('customerClass.surname')} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                            <Form.Item
                                {...twoColFormItemLayout}
                                name="firstname"
                                label={t('customerClass.firstname')}
                                initialValue={props.data.firstname}
                                rules={[
                                    {
                                        required: true,
                                        message: t('errorMessages.firstnameReq'),
                                    },
                                ]}
                            >
                                <Input placeholder={t('customerClass.firstname')} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                            <Form.Item
                                {...twoColFormItemLayout}
                                name="stateOfBirthId"
                                label={t('customerClass.stateOfBirth')}
                                initialValue={props.data.stateOfBirthId}
                                rules={[
                                    {
                                        required: true,
                                        message: t('errorMessages.stateOfBirthReq'),
                                    },
                                ]}
                            >
                                <Select
                                    placeholder={t('customerClass.stateOfBirth')}
                                    showSearch
                                    optionFilterProp="children"
                                    onChange={onStateChange}
                                    filterOption={(input, option) => option!.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                >
                                    {states.map((state) => (
                                        <Option key={state.value} value={state.value} id={'stateB-' + state.value} data-state={state.label}>
                                            {state.label}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                            <Form.Item
                                {...twoColFormItemLayout}
                                label={t('customerClass.cityOfBirth')}
                                initialValue={props.data.cityOfBirthId}
                                name="cityOfBirthId"
                                rules={[
                                    {
                                        required: true,
                                        message: t('errorMessages.cityOfBirthReq'),
                                    },
                                ]}
                            >
                                <Select
                                    placeholder={t('customerClass.cityOfBirth')}
                                    showSearch
                                    optionFilterProp="children"
                                    filterOption={(input, option) => option!.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                >
                                    {citiesOfBirth.map((city) => (
                                        <Option key={city.value} value={city.value} id={'cityB-' + city.value} data-city={city.label}>
                                            {city.label}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                            <Form.Item
                                {...twoColFormItemLayout}
                                name="dateOfBirth"
                                label={t('customerClass.dateOfBirth')}
                                initialValue={props.data.dateOfBirth}
                                rules={[
                                    {
                                        required: true,
                                        message: t('errorMessages.dateOfBirthReq'),
                                    },
                                ]}
                            >
                                <DatePicker format={shortDateFormat} disabledDate={utils.DisableDateAgeOfMajority} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                            <Form.Item
                                {...twoColFormItemLayout}
                                name="fiscalId"
                                label={t('customerClass.fiscalCode')}
                                initialValue={props.data.fiscalId}
                                rules={[
                                    {
                                        required: true,
                                        validator: utils.ValidateFiscalCode,
                                        message: t('errorMessages.fiscalCodeReq'),
                                    },
                                ]}
                            >
                                <Input placeholder={t('customerClass.fiscalCode')} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={24} sm={24} md={12} lg={12} xl={12}></Col>
                    </Row>
                    <h5 className="font-weight-600 title_content">{t('sicuri&protetti.subtitles.subtitle1')}</h5>
                    <Row>
                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                            <Form.Item
                                {...twoColFormItemLayout}
                                name="cityResidenceId"
                                label={t('customerClass.cityOfResidence')}
                                initialValue={props.data.cityResidenceId}
                                rules={[
                                    {
                                        required: true,
                                        message: t('errorMessages.cityOfResidenceReq'),
                                    },
                                ]}
                            >
                                <Select
                                    placeholder={t('customerClass.cityOfResidence')}
                                    showSearch
                                    optionFilterProp="children"
                                    onSelect={onCitySelectedR}
                                    filterOption={(input, option) => option!.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                >
                                    {citiesOfResidence.map((city) => (
                                        <Option
                                            key={city.value}
                                            value={city.value}
                                            id={'cityR-' + city.value}
                                            data-city={city.label}
                                            data-province={city.additionalData[0]}
                                            data-postalcode={city.additionalData[1]}
                                        >
                                            {city.label}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                            <Form.Item
                                {...twoColFormItemLayout}
                                name="postalCodeResidence"
                                label={t('customerClass.postalCode')}
                                initialValue={props.data.postalCodeResidence}
                                rules={[
                                    {
                                        required: true,
                                        message: t('errorMessages.postalCodeReq'),
                                    },
                                    {
                                        pattern: postalCodePattern,
                                        message: t('errorMessages.postalCodeValid'),
                                    },
                                ]}
                            >
                                <Input placeholder={t('customerClass.postalCodeSN')} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                            <Form.Item
                                {...twoColFormItemLayout}
                                name="addressResidence"
                                label={t('customerClass.address')}
                                initialValue={props.data.addressResidence}
                                rules={[
                                    {
                                        required: true,
                                        message: t('errorMessages.residentialAddressReq'),
                                    },
                                ]}
                            >
                                <Input placeholder={t('customerClass.address')} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <h5 className="font-weight-600 title_content">{t('sicuri&protetti.subtitles.subtitle3')}</h5>
                    <Row>
                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                            <Form.Item
                                {...twoColFormItemLayout}
                                name="docTypeId"
                                label={t('customerClass.docType')}
                                initialValue={props.data.docTypeId}
                                rules={[
                                    {
                                        required: true,
                                        message: t('errorMessages.docTypeReq'),
                                    },
                                ]}
                            >
                                <Select
                                    placeholder={t('customerClass.docType')}
                                    showSearch
                                    optionFilterProp="children"
                                    filterOption={(input, option) => option!.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                >
                                    {docTypes.map((docType) => (
                                        <Option
                                            key={docType.value}
                                            value={docType.value}
                                            id={'doctype-' + docType.value}
                                            data-doctype={docType.label}
                                        >
                                            {docType.label}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                            <Form.Item
                                {...twoColFormItemLayout}
                                name="docNumber"
                                label={t('customerClass.docNum')}
                                initialValue={props.data.docNumber}
                                rules={[
                                    {
                                        required: true,
                                        message: t('errorMessages.docNumReq'),
                                    },
                                ]}
                            >
                                <Input placeholder={t('customerClass.docNum')} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                            <Form.Item
                                {...twoColFormItemLayout}
                                name="releasedBy"
                                label={t('customerClass.releasedBy')}
                                initialValue={props.data.releasedBy}
                                rules={[
                                    {
                                        required: true,
                                        message: t('errorMessages.relByReq'),
                                    },
                                ]}
                            >
                                <Input placeholder={t('customerClass.releasedByPH')} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                            <Form.Item
                                {...twoColFormItemLayout}
                                name="releasedOn"
                                label={t('customerClass.releasedOn')}
                                initialValue={props.data.releasedOn}
                                rules={[
                                    {
                                        required: true,
                                        message: t('errorMessages.relOnReq'),
                                    },
                                ]}
                            >
                                <DatePicker format={shortDateFormat} disabledDate={utils.DisableDateOfFuture} />
                            </Form.Item>
                        </Col>
                    </Row>
                </>
            ) : (
                <>
                    <Row>
                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                            <Form.Item
                                {...twoColFormItemLayout}
                                name="businessName"
                                label={t('customerClass.businessName')}
                                initialValue={props.data.businessName}
                                rules={[
                                    {
                                        required: true,
                                        message: t('errorMessages.businessNameReq'),
                                    },
                                ]}
                            >
                                <Input placeholder={t('customerClass.businessName')} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                            <Form.Item
                                {...twoColFormItemLayout}
                                name="vatNumber"
                                label={t('customerClass.vatId')}
                                initialValue={props.data.vatNumber}
                                rules={[
                                    {
                                        required: true,
                                        validator: utils.ValidateVatNumber,
                                        message: t('errorMessages.VATCodeReq'),
                                    },
                                ]}
                            >
                                <Input placeholder={t('customerClass.vatId')} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                            <Form.Item {...twoColFormItemLayout} name="sdi" label={t('customerClass.sdi')} initialValue={props.data.sdi}>
                                <Input placeholder={t('customerClass.sdi')} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                            <Form.Item
                                {...twoColFormItemLayout}
                                name="pec"
                                label={t('customerClass.pec')}
                                initialValue={props.data.pec}
                                rules={[
                                    {
                                        pattern: emailPattern,
                                        message: t('errorMessages.emailValid'),
                                    },
                                ]}
                            >
                                <Input placeholder={t('customerClass.pec')} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <h5 className="font-weight-600 title_content">{t('sicuri&protetti.subtitles.subtitle5')}</h5>
                    <Row>
                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                            <Form.Item
                                {...twoColFormItemLayout}
                                name="citySocietyId"
                                label={t('commonClass.city')}
                                initialValue={props.data.citySocietyId}
                                rules={[
                                    {
                                        required: true,
                                        message: t('errorMessages.cityReq'),
                                    },
                                ]}
                            >
                                <Select
                                    placeholder={t('commonClass.city')}
                                    showSearch
                                    optionFilterProp="children"
                                    onSelect={onCitySelectedS}
                                    filterOption={(input, option) => option!.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                >
                                    {citiesOfResidence.map((city) => (
                                        <Option
                                            key={city.value}
                                            value={city.value}
                                            id={'cityS-' + city.value}
                                            data-city={city.label}
                                            data-province={city.additionalData[0]}
                                            data-postalcode={city.additionalData[1]}
                                        >
                                            {city.label}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                            <Form.Item
                                {...twoColFormItemLayout}
                                name="postalCodeSociety"
                                label={t('customerClass.postalCode')}
                                initialValue={props.data.postalCodeSociety}
                                rules={[
                                    {
                                        required: true,
                                        message: t('errorMessages.postalCodeReq'),
                                    },
                                    {
                                        pattern: postalCodePattern,
                                        message: t('errorMessages.postalCodeValid'),
                                    },
                                ]}
                            >
                                <Input placeholder={t('customerClass.postalCodeSN')} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                            <Form.Item
                                {...twoColFormItemLayout}
                                name="addressSociety"
                                label={t('customerClass.address')}
                                initialValue={props.data.addressSociety}
                                rules={[
                                    {
                                        required: true,
                                        message: t('errorMessages.addressReq'),
                                    },
                                ]}
                            >
                                <Input placeholder={t('customerClass.address')} />
                            </Form.Item>
                        </Col>
                    </Row>
                </>
            )}
            <h5 className="font-weight-600 title_content">{t('sicuri&protetti.subtitles.subtitle4')}</h5>
            <Row>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <Form.Item
                        {...twoColFormItemLayout}
                        name="tel1"
                        label={t('customerClass.tel1')}
                        initialValue={props.data.tel1}
                        rules={[
                            {
                                required: true,
                                message: t('errorMessages.telReq'),
                            },
                            {
                                pattern: telefonNumberPattern,
                                message: t('errorMessages.telReq'),
                            },
                        ]}
                    >
                        <Input placeholder={t('customerClass.tel1')} />
                    </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <Form.Item
                        {...twoColFormItemLayout}
                        name="tel2"
                        label={t('customerClass.tel2')}
                        initialValue={props.data.tel2}
                        rules={[
                            {
                                pattern: telefonNumberPattern,
                                message: t('errorMessages.telReq'),
                            },
                        ]}
                    >
                        <Input placeholder={t('customerClass.tel2')} />
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <Form.Item
                        {...twoColFormItemLayout}
                        name="email"
                        label={t('customerClass.emailAddress')}
                        initialValue={props.data.email}
                        rules={[
                            {
                                required: true,
                                message: t('errorMessages.emailReq'),
                            },
                            {
                                pattern: emailPattern,
                                message: t('errorMessages.emailValid'),
                            },
                        ]}
                    >
                        <Input placeholder={t('customerClass.emailAddress')} />
                    </Form.Item>
                </Col>
            </Row>
            <Form.Item>
                <Button type="primary" htmlType="submit" id="customer-submit" hidden />
            </Form.Item>
        </Form>
    );
};

export default CustomerForm;
